export default "__VITE_PUBLIC_ASSET__6b98d151__"